import React, { useRef } from 'react'
import cn from 'classnames'
import { number, object, string } from 'prop-types'
import { Highlight } from 'react-instantsearch-dom'
import { trackClick } from '../events'
import { getSearchIndex } from '../getSearchIndex'
import classes from './Camp.module.scss'

const fireTrackClick = (query, index, campId, moduleId, pageSource, taskId) => {
  trackClick({
    query,
    index,
    camp_id: campId,
    ...(moduleId ? { module_id: moduleId } : {}),
    ...(taskId ? { task_id: taskId } : {}),
    ...(pageSource && { page_source: pageSource }),
  })
}

export const Camp = ({
  campId,
  hit,
  image = '',
  instructorNames = '',
  moduleId,
  pageSource,
  query,
  subtitleAttribute = 'instructor_names',
  taskId,
  title = '',
  titleAttribute = 'camp_title',
  url,
}) => {
  const searchRef = useRef(null)

  const separator = ', '
  const mergedInstructorNames = instructorNames.join(separator)

  return (
    <a
      data-role='search-hit'
      ref={searchRef}
      href={url}
      className={cn(classes.wrapper, 'd-flex mc-p-4')}
      onClick={() =>
        fireTrackClick(
          query,
          getSearchIndex(searchRef.current),
          campId,
          moduleId,
          pageSource,
          taskId,
        )
      }
    >
      {image && (
        <img
          alt={mergedInstructorNames}
          className={cn(classes.image, 'mc-corners--rounded')}
          src={image}
        />
      )}
      <div className={cn(classes.textWrapper, 'd-flex mc-pl-4')}>
        <span className={cn(classes.name, 'mc-text-h6')}>
          {hit ? (
            <Highlight
              attribute={subtitleAttribute}
              hit={hit}
              separator={separator}
            />
          ) : (
            mergedInstructorNames
          )}
        </span>
        <span className={cn(classes.headline, 'mc-text-small')}>
          {hit ? <Highlight attribute={titleAttribute} hit={hit} /> : title}
        </span>
      </div>
    </a>
  )
}

Camp.propTypes = {
  campId: number.isRequired,
  hit: object.isRequired,
  image: string,
  instructorNames: string,
  moduleId: number,
  pageSource: string,
  query: string.isRequired,
  subtitleAttribute: string,
  taskId: number,
  title: string,
  titleAttribute: string,
  url: string.isRequired,
}
